module.exports = __webpack_public_path__ + "static/media/49.bdd75c02.jpg";